import type { CaseTemplateFormFieldsInner } from "src/clients/case-management";

export const getEmptyFormValues = (
  fields: CaseTemplateFormFieldsInner[] | undefined,
): Record<string, unknown> => {
  const values: Record<string, unknown> = {};
  fields?.forEach((field) => {
    values[field.key] = field.type === "multi_select" ? [] : null;
  });
  return values;
};

// For fields with active hints, preserve the previously saved values
// instead of saving the hint values
export const excludeHintedFields = (
  currentValues: Record<string, unknown>,
  fieldHints: Record<string, unknown>,
  savedValues: Record<string, unknown>,
  templateFields: CaseTemplateFormFieldsInner[] | undefined,
): Record<string, unknown> =>
  Object.fromEntries(
    Object.entries(currentValues).map(([key, value]) =>
      key in fieldHints
        ? [
            key,
            savedValues[key] ??
              (templateFields?.find((f) => f.key === key)?.type ===
              "multi_select"
                ? []
                : null),
          ]
        : [key, value],
    ),
  );
